(function () {
  if (window.BloomliVolumeTier) {
    window.BloomliVolumeTier.init(document);
    return;
  }

  function ensureDollarPrefix(value) {
    const formatted = String(value || '').trim();
    if (!formatted || formatted.indexOf('$') !== -1) return formatted;
    return '$' + formatted;
  }

  function formatMoney(cents, moneyFormat) {
    let formatted;

    if (window.Shopify && window.Shopify.formatMoney) {
      try {
        formatted = window.Shopify.formatMoney(cents, moneyFormat);
        return ensureDollarPrefix(formatted);
      } catch (error) {
        formatted = (cents / 100).toFixed(2);
        return ensureDollarPrefix(formatted);
      }
    }

    formatted = (cents / 100).toFixed(2);
    return ensureDollarPrefix(formatted);
  }

  function formatDiscount(percent) {
    return String(Math.floor(percent || 0));
  }

  function parseCents(value) {
    const cents = parseFloat(value);
    return Number.isFinite(cents) ? Math.round(cents) : 0;
  }

  function formatTemplate(template, replacements) {
    return Object.keys(replacements).reduce(function (label, key) {
      return label.split('[' + key + ']').join(replacements[key]);
    }, template || '');
  }

  function initRoot(root) {
    if (!root || root.dataset.bloomliVtInitialized === 'true') return;
    root.dataset.bloomliVtInitialized = 'true';

    const sizes = root.querySelectorAll('[data-vt-size]');
    const modes = root.querySelectorAll('[data-vt-mode]');
    const qtyInput = root.querySelector('[data-vt-qty-input]');
    const spInput = root.querySelector('[data-vt-sp-input]');
    const totalEl = root.querySelector('[data-vt-total]');
    const compareEl = root.querySelector('[data-vt-compare]');
    const oneTimePriceEl = root.querySelector('[data-vt-onetime-price]');
    const subscribePriceEl = root.querySelector('[data-vt-subscribe-price]');
    const subSavingsEl = root.querySelector('[data-vt-sub-savings]');
    const barEl = root.querySelector('[data-vt-mode-bar]');
    const modeSubInfoEl = root.querySelector('[data-vt-mode-sub-info]');
    const modeOnetimeInfoEl = root.querySelector('[data-vt-mode-onetime-info]');
    const modeSubCompareEl = root.querySelector('[data-vt-mode-subscribe-compare]');
    const modeSubSavingsEl = root.querySelector('[data-vt-mode-subscribe-savings]');
    const modeOnetimeCompareEl = root.querySelector('[data-vt-mode-onetime-compare]');
    const modeOnetimeSavingsEl = root.querySelector('[data-vt-mode-onetime-savings]');
    const atc = root.querySelector('[data-vt-atc]');
    const atcHome = root.querySelector('[data-vt-atc-home]');
    const mobileAtcSlots = root.querySelectorAll('[data-vt-mobile-atc-slot]');
    const mobileMedia = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    const onetimeDirectBtn = root.querySelector('[data-vt-onetime-direct]');
    const onetimeDailyEl = root.querySelector('[data-vt-onetime-daily]');

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const discountBadgeTemplate = root.dataset.discountBadgeTemplate || 'SAVE [percent]%';
    const savingsPrefix = root.dataset.savingsPrefix || "You're saving ";
    const savingsSuffix = root.dataset.savingsSuffix || '';
    const productFormId = root.dataset.formId;
    const productForm = productFormId ? document.getElementById(productFormId) : null;
    const variantInput = productForm ? productForm.querySelector('input[name="id"]') : root.querySelector('input[name="id"]');
    const submitButton = root.querySelector('[data-vt-submit-button]');
    const submitText = root.querySelector('[data-vt-submit-text]');
    const addToCartLabel = root.dataset.addToCartLabel || 'Add to cart';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const quantitySelector = productFormId
      ? Array.from(document.querySelectorAll('input[name="quantity"]')).find(function (input) {
          return input !== qtyInput && input.getAttribute('form') === productFormId;
        })
      : null;

    function getSelectedSize() {
      return root.querySelector('[data-vt-size].is-selected') || sizes[0];
    }

    function getSelectedMode() {
      const mode = root.querySelector('[data-vt-mode].is-selected');
      return mode ? mode.dataset.mode : 'onetime';
    }

    function setMode(modeToSelect) {
      modes.forEach(function (mode) {
        const selected = mode.dataset.mode === modeToSelect;
        mode.classList.toggle('is-selected', selected);

        const radio = mode.querySelector('.bloomli-vt__radio-native');
        if (radio) radio.checked = selected;

        mode.querySelectorAll('.bloomli-vt__subscribe-accordion, .bloomli-vt__onetime-accordion').forEach(function (accordion) {
          accordion.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
      });
    }

    function placeAddToCart() {
      if (!atc || !atcHome) return;

      const isMobile = mobileMedia ? mobileMedia.matches : window.innerWidth < 750;
      mobileAtcSlots.forEach(function (slot) {
        slot.classList.remove('has-button');
      });

      if (!isMobile) {
        if (atc.previousElementSibling !== atcHome) {
          atcHome.after(atc);
        }
        return;
      }

      const selectedMode = getSelectedMode();
      const slot = root.querySelector('[data-vt-mobile-atc-slot="' + selectedMode + '"]');

      if (slot && atc.parentNode !== slot) {
        slot.appendChild(atc);
      }

      if (slot) {
        slot.classList.add('has-button');
      }
    }

    function setSubmitState(canSubmit) {
      if (!submitButton) return;

      if (canSubmit) {
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
      } else {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-disabled', 'true');
      }

      if (submitText) {
        submitText.textContent = canSubmit ? addToCartLabel : soldOutLabel;
      }
    }

    function updateState() {
      const size = getSelectedSize();
      if (!size) return;

      const qty = parseInt(size.dataset.quantity, 10) || 1;
      const cartQuantity = parseInt(size.dataset.cartQuantity, 10) || 1;
      const variantId = size.dataset.variantId || '';
      const isAvailable = size.dataset.available === 'true';
      const canSubmit = Boolean(variantId) && isAvailable;
      const planId = size.dataset.planId || '';
      const mode = getSelectedMode();
      const oneTimeCents = parseCents(size.dataset.oneTimeCents) || 0;
      const subscribeCents = parseCents(size.dataset.subscribeCents) || oneTimeCents;
      const lineCompareCents = parseCents(size.dataset.lineCompareCents) || oneTimeCents;
      if (oneTimePriceEl) oneTimePriceEl.textContent = formatMoney(oneTimeCents, moneyFormat);
      if (subscribePriceEl) subscribePriceEl.textContent = formatMoney(subscribeCents, moneyFormat);

      if (onetimeDailyEl) {
        const dailyCents = qty > 0 ? Math.round(oneTimeCents / qty / 30) : 0;
        onetimeDailyEl.textContent = dailyCents > 0
          ? '(' + formatMoney(dailyCents, moneyFormat) + ' / Day)'
          : '';
      }

      const sizeDaily = size.querySelector('[data-vt-daily]');
      const sizeLabel = size.dataset.sizeLabel || '';
      const sizeCount = size.dataset.sizeCount || '';

      const subDailyStr = sizeDaily ? (sizeDaily.dataset.subscribeDaily || '') : '';
      const onetimeDailyStr = sizeDaily ? (sizeDaily.dataset.onetimeDaily || '') : '';

      function escapeHTML(value) {
        return String(value || '').replace(/[&<>"']/g, function (character) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
          }[character];
        });
      }

      function compactDailyText(dailyText) {
        return String(dailyText || '')
          .replace(/[()]/g, '')
          .replace(/\s*\/\s*/g, '/')
          .replace(/\bday\b/i, 'day')
          .trim();
      }

      function modeInfoHTML(label, count, dailyText) {
        const labelHTML = label ? '<strong>' + escapeHTML(label) + '</strong>' : '';
        const countHTML = count ? (label ? ' &middot; ' : '') + escapeHTML(count) : '';
        const desktopDailyHTML = dailyText
          ? (label || count ? ' &middot; ' : '') + escapeHTML(dailyText)
          : '';
        const mobileDailyHTML = dailyText ? escapeHTML(compactDailyText(dailyText)) : '';

        return '<span class="bloomli-vt__mode-info-main">' + labelHTML + countHTML + '</span>'
          + (dailyText
            ? '<span class="bloomli-vt__mode-info-daily-desktop">' + desktopDailyHTML + '</span>'
              + '<span class="bloomli-vt__mode-info-daily-mobile">' + mobileDailyHTML + '</span>'
            : '');
      }

      if (modeSubInfoEl) modeSubInfoEl.innerHTML = modeInfoHTML(sizeLabel, sizeCount, subDailyStr);
      if (modeOnetimeInfoEl) modeOnetimeInfoEl.innerHTML = modeInfoHTML(sizeLabel, sizeCount, onetimeDailyStr);

      // Savings use a whole-dollar amount, with old saved "$" suffixes normalized to the left.
      function savingsText(savingsCents) {
        if (savingsCents <= 50) return '';
        const dollars = Math.round(savingsCents / 100);
        const suffix = savingsSuffix === '$' ? '' : savingsSuffix;
        const prefixGlue = savingsPrefix && !/\s$/.test(savingsPrefix) ? ' ' : '';
        return savingsPrefix + prefixGlue + '$' + dollars + suffix;
      }

      if (lineCompareCents > subscribeCents) {
        if (modeSubCompareEl) modeSubCompareEl.textContent = formatMoney(lineCompareCents, moneyFormat);
        if (modeSubSavingsEl) modeSubSavingsEl.textContent = savingsText(lineCompareCents - subscribeCents);
      } else {
        if (modeSubCompareEl) modeSubCompareEl.textContent = '';
        if (modeSubSavingsEl) modeSubSavingsEl.textContent = '';
      }

      if (lineCompareCents > oneTimeCents) {
        if (modeOnetimeCompareEl) modeOnetimeCompareEl.textContent = formatMoney(lineCompareCents, moneyFormat);
        if (modeOnetimeSavingsEl) modeOnetimeSavingsEl.textContent = savingsText(lineCompareCents - oneTimeCents);
      } else {
        if (modeOnetimeCompareEl) modeOnetimeCompareEl.textContent = '';
        if (modeOnetimeSavingsEl) modeOnetimeSavingsEl.textContent = '';
      }

      // Dynamic bar text: "Most Popular · Get [percent]% Off"
      if (barEl) {
        const barTemplate = barEl.dataset.barTemplate || '';
        let subPct = 0;
        if (lineCompareCents > subscribeCents && lineCompareCents > 0) {
          subPct = (lineCompareCents - subscribeCents) / lineCompareCents * 100;
        }
        barEl.textContent = formatTemplate(barTemplate, { percent: formatDiscount(subPct) });
      }

      if (mode === 'subscribe' && !planId) {
        setMode('onetime');
      }

      const effectiveMode = getSelectedMode();
      const displayCents = effectiveMode === 'subscribe' && planId ? subscribeCents : oneTimeCents;

      if (variantInput && variantId) {
        variantInput.value = String(variantId);
        variantInput.disabled = !canSubmit;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (variantInput) {
        variantInput.disabled = true;
      }

      if (quantitySelector) {
        quantitySelector.value = String(cartQuantity);
        if (qtyInput) qtyInput.disabled = true;
      } else if (qtyInput) {
        qtyInput.value = String(cartQuantity);
        qtyInput.disabled = false;
      }

      if (effectiveMode === 'subscribe' && planId) {
        if (spInput) {
          spInput.value = String(planId);
          spInput.disabled = false;
        }
      } else if (spInput) {
        spInput.value = '';
        spInput.disabled = true;
      }

      if (totalEl) totalEl.textContent = formatMoney(displayCents, moneyFormat);

      if (compareEl) {
        if (lineCompareCents > displayCents) {
          compareEl.textContent = formatMoney(lineCompareCents, moneyFormat);
        } else {
          compareEl.textContent = '';
        }
      }

      sizes.forEach(function (sizeOption) {
        const badge = sizeOption.querySelector('[data-vt-discount-badge]');
        if (!badge) return;

        const qtyForLabel = parseInt(sizeOption.dataset.quantity, 10) || 1;
        const volumeDiscount = parseFloat(sizeOption.dataset.discountPct) || 0;
        const manualBadge = badge.dataset.manualBadge || '';

        let displayDiscount = volumeDiscount;
        if (effectiveMode === 'subscribe' && sizeOption.dataset.planId) {
          const sizeSubscribeCents = parseCents(sizeOption.dataset.subscribeCents) || 0;
          const sizeLineCompareCents = parseCents(sizeOption.dataset.lineCompareCents) || 0;
          if (sizeLineCompareCents > sizeSubscribeCents && sizeLineCompareCents > 0) {
            displayDiscount = (sizeLineCompareCents - sizeSubscribeCents) / sizeLineCompareCents * 100;
          }
        }

        if (displayDiscount > 0) {
          badge.textContent = formatTemplate(discountBadgeTemplate, {
            qty: String(qtyForLabel),
            percent: formatDiscount(displayDiscount),
          });
        } else {
          badge.textContent = manualBadge;
        }
      });

      sizes.forEach(function (sizeOption) {
        const daily = sizeOption.querySelector('[data-vt-daily]');
        if (!daily) return;

        const nextDaily =
          effectiveMode === 'subscribe' && sizeOption.dataset.planId
            ? daily.dataset.subscribeDaily
            : daily.dataset.onetimeDaily;

        if (nextDaily) daily.textContent = nextDaily;
      });

      modes.forEach(function (modeOption) {
        if (modeOption.dataset.mode !== 'subscribe') return;

        if (!planId) {
          modeOption.setAttribute('aria-disabled', 'true');
          modeOption.classList.add('is-disabled');
        } else {
          modeOption.removeAttribute('aria-disabled');
          modeOption.classList.remove('is-disabled');
        }
      });

      setSubmitState(canSubmit);
      placeAddToCart();
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(placeAddToCart);
      }
    }

    sizes.forEach(function (size) {
      size.addEventListener('click', function () {
        sizes.forEach(function (sizeOption) {
          sizeOption.classList.remove('is-selected');

          const radio = sizeOption.querySelector('.bloomli-vt__radio-native');
          if (radio) radio.checked = false;
        });

        size.classList.add('is-selected');

        const radio = size.querySelector('.bloomli-vt__radio-native');
        if (radio) radio.checked = true;

        const defaultMode = size.dataset.vtDefaultMode;
        if (defaultMode) setMode(defaultMode);

        updateState();
      });
    });

    modes.forEach(function (mode) {
      mode.addEventListener('click', function (event) {
        if (event.target.closest('[data-vt-atc]')) return;
        if (mode.getAttribute('aria-disabled') === 'true') return;

        setMode(mode.dataset.mode);
        updateState();
      });
    });

    if (onetimeDirectBtn) {
      onetimeDirectBtn.addEventListener('click', function () {
        const size = getSelectedSize();
        if (!size) return;

        const variantId = size.dataset.variantId || '';
        const cartQuantity = parseInt(size.dataset.cartQuantity, 10) || 1;
        const isAvailable = size.dataset.available === 'true';

        if (!variantId || !isAvailable) return;

        if (variantInput) {
          variantInput.value = variantId;
          variantInput.disabled = false;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (qtyInput) qtyInput.value = String(cartQuantity);
        if (spInput) {
          spInput.value = '';
          spInput.disabled = true;
        }

        const form = productFormId ? document.getElementById(productFormId) : null;
        if (form) {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }

    if (mobileMedia) {
      if (mobileMedia.addEventListener) {
        mobileMedia.addEventListener('change', placeAddToCart);
      } else if (mobileMedia.addListener) {
        mobileMedia.addListener(placeAddToCart);
      }
    } else {
      window.addEventListener('resize', placeAddToCart);
    }

    if (!root.querySelector('[data-vt-size].is-selected') && sizes[0]) {
      sizes[0].classList.add('is-selected');

      const radio = sizes[0].querySelector('.bloomli-vt__radio-native');
      if (radio) radio.checked = true;
    }

    if (!root.querySelector('[data-vt-mode].is-selected') && modes[0]) {
      setMode(modes[0].dataset.mode);
    }

    setMode(getSelectedMode());
    updateState();
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-bloomli-vt]').forEach(initRoot);
  }

  window.BloomliVolumeTier = {
    init: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
